import 'bootstrap/dist/css/bootstrap.min.css';

import './App.css';

import { useMemo, useState } from 'react';

import {
  Container,
  Row,
  Button,
  Form,
  Navbar,
  Offcanvas
} from 'react-bootstrap';

import IntegrationList from './components/integrationlist';
import ConfigForm from './components/configform';
import withIntegrationsGetter from './containers/withintegrationgetter';
import withIntegrationsCreator from './containers/withintegrationscreate';
import withLoginInitiator from './containers/withlogininitiator';


function App(props) {
  const [show, setShow] = useState(false);
  const [integration, setIntegration] = useState({});

  const handleClose = () => setShow(false);
  const handleShow = (integration) => {
    setIntegration(integration);
    setShow(true);
  };
  const handleSave = () => {
    handleClose();
    props.onUpdateIntegrations();
  };

  const onCreate = async (integration) => {
    await props.onCreate(integration);
    handleSave();
  };

  const onUpdate = async (integration) => {
    await props.onUpdate(integration);
    handleSave();
  };

  const onDelete = async (integration) => {
    await props.onDelete(integration);
    handleSave();
  };

  const [syncingPrices, setSyncingPrices] = useState(false);
  const [search, setSearch] = useState('');

  const visibleIntegrations = useMemo(() => {
    const term = search.trim().toLowerCase();
    const filtered = (props.integrations || []).filter(
      (integration) => !term || integration.common.site_name.toLowerCase().includes(term)
    );

    return [...filtered].sort((a, b) => {
      const aEnabled = !!a.common?.enabled;
      const bEnabled = !!b.common?.enabled;
      if (aEnabled !== bEnabled) return aEnabled ? -1 : 1;
      return a.common.site_name.localeCompare(b.common.site_name);
    });
  }, [props.integrations, search]);

  return (
    <>
      <Navbar bg="dark" variant="dark" sticky="top" expand="lg">
        <Container>
          <Navbar.Brand href="#home">Integración de Productos</Navbar.Brand>
          <Button
            className='float-end'
            onClick={() => {
              if (props.isLoggedIn)
                handleShow({});
              else
                props.initLogin();
            }}
          >{ props.isLoggedIn ? "+": "Login"}</Button>
        </Container>
      </Navbar>
      <Container>
        {
          props.isLoggedIn && !props.isLoading && props.integrations?.length > 0 &&
          <Form.Control
            className='mt-4'
            type='search'
            placeholder='Buscar sitio...'
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        }
        <Row className='row-cols-2 row-cols-md-3 g-4 py-4' >
          {
            props.isLoggedIn ?
              <IntegrationList
                integrations={visibleIntegrations}
                isLoading={props.isLoading}
                search={search.trim()}
                onDelete={onDelete}
                onEditClick={
                  (integration) => {
                    handleShow(integration);
                  }
                }
              />
              :
              null
          }

        </Row>
      </Container>

      <Offcanvas style={{width: "600px"}} placement="end" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Configurar integración</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ConfigForm
            key={integration.id || 'new'}
            integration={integration}
            isProcessing={props.isProcessing}
            onCreate={onCreate}
            onUpdate={onUpdate}
            access_token={props.access_token}
            syncingPrices={syncingPrices}
            setSyncingPrices={setSyncingPrices}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default withLoginInitiator(
  withIntegrationsCreator(
    withIntegrationsGetter(App)
  ),
  {
    redirect_url: process.env.REACT_APP_REDIRECT_URL,
    client_id: process.env.REACT_APP_CLIENT_ID,
    site_name: "baymax",
    client_secret: process.env.REACT_APP_CLIENT_SECRET
  }
);
